import { useContext } from "react";

import Context from "./JarvisContext";

const useJarvisContext = () => useContext(Context);

export default useJarvisContext;
